export default __webpack_public_path__ + "static/media/ProductIllustration.44d27688.svg";